export * from './tab.component';
export * from './tabs.component';
export * from './tab.model' ;
